import { IPartnerDto } from "src/shared/types/partner.types";
import { TIntegration1CStatus } from "../model/constants";

export const getIntegration1CStatus = (
  integration_1c: IPartnerDto["integration_1c"],
): TIntegration1CStatus => {
  if (!integration_1c) return "ERP_ONLY";
  const { is_success, is_job_send, exception_message } = integration_1c;

  if (is_success && !exception_message) return "SUCCESS";
  if (is_success && exception_message) return "ERP_ONLY";
  if (!is_success && is_job_send) return "IN_QUEUE";

  return "ERROR";
};
